import { useEffect } from "react"
import pb, { redirectUrl } from "../../../lib/pocketbase"
import { useLocalStorage } from "../../../Utils"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons"
import classes from "./FlioSync.module.css"

const FlioSync = props => {
    const [provider, setProvider] = useLocalStorage("provider", {})

    useEffect(() => {
        if (!pb.authStore.isValid && Object.keys(provider).length === 0) {
            pb.collection("users")
                .listAuthMethods()
                .then(a => {
                    setProvider(a.authProviders[0])
                })
        }
    }, [setProvider, provider])

    const logout = () => {
        pb.authStore.clear()
        setProvider("")
    }

    return (
        <div className={classes.Upper}>
            {pb.authStore.isValid ? (
                <>
                    <img src={pb.authStore.model.avatarUrl} alt={"avatar"} className={classes.Avatar} />
                    <button onClick={() => logout()}>
                        <FontAwesomeIcon icon={faRightFromBracket} />
                        Log out
                    </button>
                </>
            ) : Object.keys(provider).length > 0 ? (
                <a href={provider.authUrl + encodeURIComponent(redirectUrl)}>Login</a>
            ) : null}
        </div>
    )
}

export default FlioSync
